// Extracted from https://spannerisms.github.io/damage/ - Thanks kan!
export const ancillaeIds: { [key: number]: string } = {
0x00: "Nothing",
0x01: "Somaria missile",
0x02: "Fire rod shot",
0x03: "Unused",
0x04: "Beam wall hit",
0x05: "Boomerang",
0x06: "Wall hit",
0x07: "Bomb",
0x08: "Door debris",
0x09: "Arrow",
0x0A: "Lodged arrow",
0x0B: "Ice shot",
0x0C: "Sword beam",
0x0D: "Max sword charge sparkle",
0x0E: "Unused",
0x0F: "Unused",
0x10: "Unused",
0x11: "Ice rod shot wall hit",
0x12: "Unused",
0x13: "Ice shot sparkle",
0x14: "Unused",
0x15: "Splash",
0x16: "Stars",
0x17: "Dirt",
0x18: "Ether",
0x19: "Bombos",
0x1A: "Powder",
0x1B: "Wall poke spark",
0x1C: "Quake",
0x1D: "Bonk screen shake",
0x1E: "Dash dust",
0x1F: "Hookshot",
0x20: "Link's blanky",
0x21: "Link snoring",
0x22: "Item get",
0x23: "Poof",
0x24: "Overworld gravestone",
0x25: "Unused",
0x26: "Sword swing sparkle",
0x27: "Duck",
0x28: "Fairy pond toss item",
0x29: "Pendant/crystal/medallion item get",
0x2A: "Spin attack sparkle",
0x2B: "Spin attack sparkle",
0x2C: "Somaria block",
0x2D: "Somaria block dying",
0x2E: "Somaria block exploding",
0x2F: "Lamp flame",
0x30: "Byrna charge up spark",
0x31: "Byrna spark",
0x32: "Blast wall explosion",
0x33: "Blast wall explosion",
0x34: "Skull Woods fire",
0x35: "Master Sword cutscene",
0x36: "Flute from ground",
0x37: "Flute spot debris",
0x38: "Flute cutscene bird",
0x39: "Somaria platform poof",
0x3A: "Super Bomb explosion",
0x3B: "Sword up sparkle",
0x3C: "Sword charge sparkle",
0x3D: "Item splash",
0x3E: "Crystal rising",
0x3F: "Bush powder poof",
0x40: "Smithy poof",
0x41: "Waterfall splash",
0x42: "Upgrade rupees",
0x43: "Ganon's Tower cutscene"
}
